import axios from 'axios';
import {Redirect} from 'react-router-dom';
import {createBrowserHistory} from 'history';
import {toast} from "react-toastify";
// eslint-disable-next-line import/no-cycle
// import { logoutUser } from '../auth/store/userSlice';

// import { showErrorMessage } from '../store/fuse/messageSlice';

export const host = process.env.REACT_APP_HOST;
const baseURL = process.env.REACT_APP_API_BASE_URL;

export const baseUrlAsync = baseURL;

const API = axios.create({
    baseURL,
    timeout: 60000
});

export const {CancelToken} = axios;
const currentExecutingRequests = {};
export const source = CancelToken.source();
API.interceptors.request.use(

    config => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
            // config.headers.credentials=true;
        }
        // config.headers.crossOrigin="*";

        // Cancel previous request to the same endpoint
        if (currentExecutingRequests[config.url]) {
            currentExecutingRequests[config.url].cancel('Request cancelled due to new request to the same endpoint');
        }
        currentExecutingRequests[config.url] = axios.CancelToken.source();
        config.cancelToken = currentExecutingRequests[config.url].token;

        return config;
    },
    async error => {
        console.log(error);
        return Promise.reject(error);
    },
)


API.interceptors.response.use(
    response => {
        // console.log(response);
        delete currentExecutingRequests[response.config.url];
        return response.data;
    },
    async error => {
        // console.log(error);
        // await showErrorMessage(error.response.data);
        // alert(JSON.stringify(error));
        if (error.config) {
            delete currentExecutingRequests[error.config.url];
        }
        if (error.response) {
            // Requests made with responseType 'blob' receive a Blob body even on
            // error responses; unwrap JSON error bodies so downstream handling
            // (toasts, thunk rejections) sees the real message instead of a Blob.
            if (error.response.data instanceof Blob && (error.response.data.type || '').indexOf('json') !== -1) {
                try {
                    error.response.data = JSON.parse(await error.response.data.text());
                } catch (e) {
                    // leave as-is if it can't be parsed
                }
            }
            //  alert(JSON.stringify(error.response));
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            // console.log(error.response.data);
            // console.log(error.response.status);
            // console.log(error.response.headers);
            if (error.response.status === 401) {
                // user is unauthorized, logout

                try {
                    // await logoutUser();
                } catch (e) {
                    return Promise.reject(e);
                }
            }
            if (error.response.status === 422) {
                // Laravel validation returns {message, errors}; abort() via the controllers returns a plain string.
                const payload = error.response.data;
                const message = typeof payload === 'string'
                    ? payload
                    : (payload && payload.message) ? payload.message : 'The request could not be processed.';
                toast.error(message, {position: toast.POSITION.TOP_RIGHT});
                return Promise.reject(error.response.data);
            }
            if (error.response.status === 403) {
                const history = createBrowserHistory({forceRefresh: true});
                history.push('/error/permission');
               // window.location.reload();
                // eslint-disable-next-line no-restricted-globals
            }
            if (error.response.status === 404) {
               const history = createBrowserHistory({forceRefresh: true});
                history.push('/error/not-found');
               window.location.reload();
                // eslint-disable-next-line no-restricted-globals
            }
            if (error.response.status === 401) {
                toast.error(error.response.data, {position: toast.POSITION.TOP_RIGHT});
                return Promise.reject(error.response.data);
            }
            if (![401, 403, 404, 422].includes(error.response.status)) {
                const payload = error.response.data;
                const message = typeof payload === 'string'
                    ? payload
                    : (payload && payload.message) ? payload.message : 'Something went wrong. Please try again or contact support.';
                toast.error(message, {position: toast.POSITION.TOP_RIGHT});
            }
        } else if (error.request) {
            // The request was made but no response was received (e.g. a timed-out or
            // proxy/server-killed request) — surface this instead of failing silently.
            toast.error('The server took too long to respond. Your changes may not have been saved — please check and try again.', {position: toast.POSITION.TOP_RIGHT});
        } else {
            // Something happened in setting up the request that triggered an Error
            // console.log('Error', error.message);
        }
        return Promise.reject(error);
    }
);

export default API;
